// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"d1b05bd4","46":"69784ee8","232":"c526e5a7","450":"043ab402","635":"8fef701a","660":"9416c7dc","858":"6d747aa6","921":"bc9266b6","977":"f8eed90f"}[chunkId] + ".chunk.js";
};